export default [
  {
    // path: 'usuarios',
    // name: 'list-users',
    // component: () => import('@/views/dashboard/Dummy.vue'),
  },
]